import {
  UTM_DEFAULT_SOURCE,
  UTM_DEFAULT_MEDIUM,
  urlSinUtmsPrincipales,
  getUtmParams,
  saveUtmParams,
  getCurrentUrlWithUtmDefaults,
  buildUtmQueryString,
} from "../utils/utmParams";

/** Compat: mismo valor que en `utmParams` (antes `landing_campaña` en esta repo). */
export const DEFAULT_UTM_SOURCE = UTM_DEFAULT_SOURCE;
export const DEFAULT_UTM_MEDIUM = UTM_DEFAULT_MEDIUM;

export {
  UTM_DEFAULT_SOURCE,
  UTM_DEFAULT_MEDIUM,
  urlSinUtmsPrincipales,
  getUtmParams,
  saveUtmParams,
  getCurrentUrlWithUtmDefaults,
  buildUtmQueryString,
};

// Configuración de números de WhatsApp por UTM parameters
export const whatsappConfig = {
  default: {
    number: "+543516825130",
    message: "Hola Automont!",
  },
  hyundaiSantaFeBot: {
    number: process.env.REACT_APP_HYUNDAI_SANTAFE_BOT_WHATSAPP || "5493517385093",
    message: "Quiero encargar la nueva Hyundai Santa Fé",
  },
};

/**
 * URL de WhatsApp con mensaje y número (solo dígitos en la URL).
 * @param {string} [message]
 * @param {string} [phoneDigits] — si no se pasa, usa `whatsappConfig.default.number`
 */
export const buildWhatsAppUrl = (message, phoneDigits) => {
  const defaultConfig = whatsappConfig.default;
  const raw = phoneDigits ?? defaultConfig.number;
  const phone = String(raw).replace(/\D/g, "");
  const encodedMessage = encodeURIComponent(message ?? defaultConfig.message);
  return `https://api.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;
};

// Función para obtener la URL de WhatsApp según los UTM parameters
export const getWhatsAppUrl = (utmParams = {}) => {
  const { utm_source, utm_campaign } = utmParams;
  const tiktok = whatsappConfig.tiktok;

  if (utm_source === "tiktok" && tiktok) {
    if (utm_campaign && tiktok.campaigns?.[utm_campaign]) {
      const campaignConfig = tiktok.campaigns[utm_campaign];
      const encodedMessage = encodeURIComponent(campaignConfig.message);
      return `https://api.whatsapp.com/send?phone=${String(campaignConfig.number).replace(/\D/g, "")}&text=${encodedMessage}`;
    }

    const encodedMessage = encodeURIComponent(tiktok.message);
    return `https://api.whatsapp.com/send?phone=${String(tiktok.number).replace(/\D/g, "")}&text=${encodedMessage}`;
  }

  if (utm_source && whatsappConfig[utm_source] && typeof whatsappConfig[utm_source] === "object" && "number" in whatsappConfig[utm_source]) {
    const config = whatsappConfig[utm_source];
    const encodedMessage = encodeURIComponent(config.message);
    return `https://api.whatsapp.com/send?phone=${String(config.number).replace(/\D/g, "")}&text=${encodedMessage}`;
  }

  const defaultConfig = whatsappConfig.default;
  const encodedMessage = encodeURIComponent(defaultConfig.message);
  return `https://api.whatsapp.com/send?phone=${String(defaultConfig.number).replace(/\D/g, "")}&text=${encodedMessage}`;
};
